import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.entity.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-entity-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.entity.review/view.scss */
:host {
  display: block;
  height: 100%;
}

.kg-source-text {
  white-space: pre-wrap;
  word-break: keep-all;
}

.kg-original-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.kg-fragment {
  display: inline;
  border: 0;
  font: inherit;
  line-height: inherit;
  color: inherit;
  cursor: pointer;
}

.kg-plain {
  padding: 0;
  cursor: default;
}

.kg-mention {
  background: rgb(219, 234, 254);
  box-shadow: inset 0 -2px 0 rgb(59, 130, 246);
}

.kg-confirmed {
  background: rgb(220, 252, 231);
  box-shadow: inset 0 -2px 0 rgb(22, 163, 74);
}

.kg-manual {
  background: rgb(220, 252, 231);
  text-decoration-line: underline;
  text-decoration-style: double;
  text-decoration-color: rgb(21, 128, 61);
  text-underline-offset: 4px;
}

.kg-excluded {
  background: rgb(244, 244, 245);
  color: rgb(113, 113, 122);
  text-decoration-line: line-through;
  text-decoration-color: rgb(113, 113, 122);
}

.kg-held {
  background: rgb(245, 243, 255);
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-decoration-color: rgb(124, 58, 237);
  text-underline-offset: 4px;
}

.kg-candidate {
  background: rgb(254, 243, 199);
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-decoration-color: rgb(217, 119, 6);
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
}

.kg-overlap {
  background: rgb(254, 226, 226);
  box-shadow: inset 0 0 0 1px rgb(248, 113, 113);
  text-decoration-line: underline;
  text-decoration-style: double;
  text-decoration-color: rgb(220, 38, 38);
  text-underline-offset: 4px;
}

.kg-fragment:hover {
  filter: saturate(1.2) brightness(0.98);
}`],
})
export class PageEntityReviewComponent implements OnInit {
    public loading: boolean = false;
    public panelLoading: boolean = false;
    private panelLoadingCount: number = 0;
    public error: any = null;

    public tabs: any[] = [
        { id: 'source', label: '원문 검수', countKey: 'source_count' },
        { id: 'recommendations', label: 'AI 추천', countKey: null },
        { id: 'mentions', label: 'Mention 결과', countKey: 'accepted_mention_count' },
        { id: 'entities', label: 'Entity 검수', countKey: 'entity_count' },
        { id: 'quality', label: '품질·확정', countKey: null },
    ];
    public activeTab: string = 'source';

    public run: any = null;
    public runs: any[] = [];
    public selectedRunKey: string = '';
    public counts: any = {};
    public blockers: string[] = [];
    public validation: any = null;
    public capabilities: any = {};
    public originalFile: any = null;
    public proposalRun: any = null;
    public reviewProgress: any = {};
    public silver: any = null;

    public recommendationSummary: any = null;
    public recommendationQuery: string = '';
    public recommendationType: string = 'all';
    public recommendationFamily: string = 'all';
    public recommendationStatus: string = 'all';
    public recommendationPage: number = 1;
    public recommendationResult: any = this.emptyPage();
    public selectedRecommendation: any = null;
    public recommendationsLoaded: boolean = false;

    public sourceFilter: string = 'pending';
    public sourceQuery: string = '';
    public sourcePage: number = 1;
    public sourceViewMode: string = 'compare';
    public sourceResult: any = this.emptyPage();
    public sourcesLoaded: boolean = false;
    public selectedSource: any = null;
    public selectedSpan: any = null;
    public overlappingSpans: any[] = [];
    public decisionType: string = 'PERSON';
    public manualType: string = 'PERSON';
    public manualSelection: any = null;
    public reviewHistoryItems: any[] = [];
    public saving: boolean = false;

    public mentionQuery: string = '';
    public mentionType: string = 'all';
    public mentionPage: number = 1;
    public mentionResult: any = this.emptyPage();

    public entityQuery: string = '';
    public entityType: string = 'all';
    public entityMethod: string = 'all';
    public entityPage: number = 1;
    public entityResult: any = this.emptyPage();
    public selectedEntity: any = null;

    public entityTypes: any[] = [
        { id: 'all', label: '전체 유형' },
        { id: 'PERSON', label: '인물' },
        { id: 'ORGANIZATION', label: '기관' },
        { id: 'TIME', label: '시간' },
        { id: 'WORK', label: '문헌' },
        { id: 'PLACE', label: '장소' },
        { id: 'OFFICE', label: '관직' },
        { id: 'EVENT', label: '사건' },
        { id: 'POLITY', label: '국가·정체' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.activeTab = this.routeTab();
        await this.loadOverview();
        await Promise.all([
            this.loadRuns(),
            this.loadActiveTab(this.activeTab),
        ]);
    }

    public async loadOverview() {
        if (this.loading) return;
        this.loading = true;
        this.error = null;
        await this.service.render();

        try {
            const identity = this.routeIdentity();
            const data = await this.call('overview', identity);
            this.run = data.run;
            this.selectedRunKey = this.run.document_key;
            this.counts = data.counts || {};
            this.blockers = data.finalization_blockers || [];
            this.validation = data.validation || {};
            this.capabilities = data.capabilities || {};
            this.originalFile = data.original_file || null;
            this.proposalRun = data.proposal_run || null;
            this.reviewProgress = data.review || {};
        } catch (error) {
            this.applyError(error);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadRuns() {
        try {
            const data = await this.call('runs', {});
            this.runs = (data.items || []).filter(
                (item: any) => item && item.document_key
            );
        } catch (_error) {
            this.runs = this.run ? [this.run] : [];
        }
        this.selectedRunKey = this.run ? this.run.document_key : '';
        await this.service.render();
    }

    public selectRun(documentKey: string) {
        this.selectedRunKey = documentKey;
        const selected = this.runs.find(
            (item: any) => item.document_key === documentKey
        );
        if (!selected || !this.run || selected.document_key === this.run.document_key) {
            return;
        }
        const documentId = encodeURIComponent(selected.document_id);
        const tab = this.activeTab === 'source'
            ? ''
            : `?tab=${encodeURIComponent(this.activeTab)}`;
        location.href = `/entity-review/${documentId}/${selected.version}${tab}`;
    }

    public runOptionLabel(item: any) {
        if (!item) return '';
        const title = item.title || item.document_id || '';
        return `v${item.version} · ${title}`;
    }

    public async switchTab(tab: string) {
        if (this.panelLoading || this.activeTab === tab) return;
        this.activeTab = tab;
        this.syncTabUrl(tab);
        this.error = null;
        await this.service.render();
        await this.loadActiveTab(tab);
    }

    private async loadActiveTab(tab: string, force: boolean = false) {
        if (tab === 'source' && (force || !this.sourcesLoaded)) {
            await this.loadSources(true);
        }
        if (tab === 'mentions' && (force || this.mentionResult.total === 0)) {
            await this.loadMentions();
        }
        if (tab === 'recommendations' && (force || !this.recommendationsLoaded)) {
            await this.loadRecommendations(true);
        }
        if (tab === 'entities' && (force || this.entityResult.total === 0)) {
            await this.loadEntities(true);
        }
        if (tab === 'quality' && (force || !this.silver)) {
            await this.loadSilverSummary();
        }
    }

    private routeTab() {
        const tab = new URLSearchParams(location.search).get('tab') || 'source';
        return this.tabs.some((item: any) => item.id === tab) ? tab : 'source';
    }

    private syncTabUrl(tab: string) {
        const url = new URL(location.href);
        if (tab === 'source') {
            url.searchParams.delete('tab');
        } else {
            url.searchParams.set('tab', tab);
        }
        history.replaceState({}, '', url.pathname + url.search + url.hash);
    }

    public async retryCurrentTab() {
        this.error = null;
        if (!this.run) {
            await this.loadOverview();
        }
        if (!this.run || this.error) return;
        await Promise.all([
            this.loadRuns(),
            this.loadActiveTab(this.activeTab, true),
        ]);
    }

    public async loadSilverSummary() {
        if (!this.run) return;
        this.error = null;
        await this.beginPanelLoading();
        try {
            const [silver, recommendationSummary] = await Promise.all([
                this.call('silver_summary', this.identity()),
                this.call('ai_recommendation_summary', this.identity()),
            ]);
            this.silver = silver;
            this.recommendationSummary = recommendationSummary;
        } catch (error) {
            this.applyError(error);
        } finally {
            await this.endPanelLoading();
        }
    }

    public async loadRecommendations(selectFirst: boolean = false) {
        if (!this.run || this.panelLoading) return;
        this.error = null;
        await this.beginPanelLoading();
        try {
            const snapshot = await this.call('ai_recommendation_snapshot', {
                ...this.identity(),
                query: this.recommendationQuery,
                entity_type: this.recommendationType,
                model_family: this.recommendationFamily,
                silver_status: this.recommendationStatus,
                page: this.recommendationPage,
                dump: 50,
            });
            this.recommendationSummary = snapshot.summary;
            this.recommendationResult = snapshot.result;
            this.recommendationsLoaded = true;
            const selectedStillVisible = this.selectedRecommendation
                && this.recommendationResult.items.some(
                    (item: any) => item.recommendation_id
                        === this.selectedRecommendation.recommendation_id
                );
            if (selectFirst || !selectedStillVisible) {
                this.selectedRecommendation = snapshot.selected_recommendation;
            }
        } catch (error) {
            this.applyError(error);
        } finally {
            await this.endPanelLoading();
        }
    }

    public async applyRecommendationFilter() {
        this.recommendationPage = 1;
        await this.loadRecommendations(true);
    }

    public async moveRecommendationPage(direction: number) {
        const target = this.recommendationPage + direction;
        if (target < 1) return;
        this.recommendationPage = target;
        await this.loadRecommendations(true);
    }

    public async openRecommendation(recommendationId: string) {
        if (!recommendationId || !this.run || this.panelLoading) return;
        await this.beginPanelLoading();
        try {
            this.selectedRecommendation = await this.call(
                'ai_recommendation_detail',
                {
                    ...this.identity(),
                    recommendation_id: recommendationId,
                },
            );
        } catch (error) {
            this.applyError(error);
        } finally {
            await this.endPanelLoading();
        }
    }

    public async loadSources(
        selectFirst: boolean = false,
        selectDefault: boolean = true,
    ) {
        if (!this.run) return;
        this.error = null;
        await this.beginPanelLoading();
        try {
            this.sourceResult = await this.call('sources', {
                ...this.identity(),
                status: this.sourceFilter,
                query: this.sourceQuery,
                page: this.sourcePage,
                dump: 60,
            });
            if (
                selectDefault
                && (
                    selectFirst
                    || !this.selectedSource
                    || !this.sourceResult.items.some(
                        (item: any) => item.id === this.selectedSource.source.id
                    )
                )
            ) {
                if (this.sourceResult.items.length > 0) {
                    await this.openSource(this.sourceResult.items[0].id);
                } else {
                    this.selectedSource = null;
                    this.selectedSpan = null;
                    this.overlappingSpans = [];
                }
            }
            this.sourcesLoaded = true;
        } catch (error) {
            this.applyError(error);
        } finally {
            await this.endPanelLoading();
        }
    }

    public async applySourceFilter() {
        this.sourcePage = 1;
        await this.loadSources(true);
    }

    public async setSourceFilter(status: string) {
        if (this.sourceFilter === status) return;
        this.sourceFilter = status;
        await this.applySourceFilter();
    }

    public async moveSourcePage(direction: number) {
        const target = this.sourcePage + direction;
        if (target < 1) return;
        this.sourcePage = target;
        await this.loadSources(true);
    }

    public async openSource(sourceId: string, spanId: string = null) {
        if (!sourceId || !this.run) return;
        await this.beginPanelLoading();
        try {
            const data = await this.call('source', {
                ...this.identity(),
                source_id: sourceId,
            });
            this.selectedSource = data;
            this.selectedSpan = null;
            this.overlappingSpans = [];
            this.manualSelection = null;
            if (spanId) {
                const span = data.spans.find((item: any) => item.id === spanId);
                if (span) this.setSelectedSpan(span);
            }
            await this.loadReviewHistory();
        } catch (error) {
            this.applyError(error);
        } finally {
            await this.endPanelLoading();
        }
    }

    public async moveAdjacentSource(direction: string) {
        if (!this.selectedSource) return;
        const target = direction === 'previous'
            ? this.selectedSource.previous_source_id
            : this.selectedSource.next_source_id;
        if (target) await this.openSource(target);
    }

    public async setSourceViewMode(mode: string) {
        if (!['compare', 'unit'].includes(mode)) return;
        this.sourceViewMode = mode;
        await this.service.render();
    }

    public async selectFragment(fragment: any) {
        if (!fragment || !Array.isArray(fragment.spans) || fragment.spans.length < 1) {
            this.selectedSpan = null;
            this.overlappingSpans = [];
            await this.service.render();
            return;
        }
        this.overlappingSpans = fragment.spans;
        const span = fragment.spans.find(
            (item: any) => item.status === 'pending'
        ) || fragment.spans[0];
        this.setSelectedSpan(span);
        await this.service.render();
    }

    public async selectSpan(span: any) {
        this.setSelectedSpan(span);
        await this.service.render();
    }

    public async captureSelection(event: any) {
        if (!this.selectedSource || !event || !event.currentTarget) return;
        const selection = window.getSelection();
        if (!selection || selection.rangeCount < 1 || selection.isCollapsed) return;
        const root = event.currentTarget as HTMLElement;
        const range = selection.getRangeAt(0);
        if (!root.contains(range.startContainer) || !root.contains(range.endContainer)) {
            return;
        }
        const prefix = range.cloneRange();
        prefix.selectNodeContents(root);
        prefix.setEnd(range.startContainer, range.startOffset);
        const start = prefix.toString().length;
        const surface = range.toString();
        const end = start + surface.length;
        if (!surface.trim() || end > this.selectedSource.text.length) return;
        this.manualSelection = {
            start,
            end,
            surface: this.selectedSource.text.slice(start, end),
        };
        await this.service.render();
    }

    public async decideSelected(action: string) {
        if (!this.selectedSource || !this.selectedSpan || this.saving) return;
        if (action === 'exclude') {
            const confirmed = await this.service.modal.show({
                title: '후보 제외',
                message: '선택한 후보를 최종 Mention에서 제외할까요?',
                action: '제외',
                cancel: '취소',
                status: 'warning',
                actionBtn: 'warning',
            });
            if (!confirmed) return;
        }
        await this.mutateSource('save_source_decision', {
            span_id: this.selectedSpan.id,
            action,
            entity_type: this.decisionType,
            start: this.selectedSpan.start,
            end: this.selectedSpan.end,
        }, this.selectedSpan.id);
    }

    public async revertSelected() {
        if (!this.selectedSpan || !this.selectedSpan.decision) return;
        await this.mutateSource('save_source_decision', {
            span_id: this.selectedSpan.id,
            action: 'revert',
        }, this.selectedSpan.id);
    }

    public async addManualMention() {
        if (!this.manualSelection || this.saving) return;
        await this.mutateSource('add_manual_mention', {
            start: this.manualSelection.start,
            end: this.manualSelection.end,
            entity_type: this.manualType,
        });
        this.manualSelection = null;
        const selection = window.getSelection();
        if (selection) selection.removeAllRanges();
        await this.service.render();
    }

    public async completeSelectedSource() {
        if (!this.selectedSource || this.saving) return;
        const review = this.selectedSource.review || {};
        if (review.pending_count > 0) {
            await this.service.modal.warning(
                '미결 후보를 모두 판단한 뒤 완료할 수 있습니다.'
            );
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '원문 검수 완료',
            message: '원문 전체와 모든 후보를 확인했음을 기록할까요?',
            action: '완료',
            cancel: '취소',
            status: 'success',
            actionBtn: 'success',
        });
        if (!confirmed) return;
        const saved = await this.mutateSource('complete_source', {
            whole_text_checked: true,
        });
        if (saved) await this.loadSources(true);
    }

    public async reopenSelectedSource() {
        if (!this.selectedSource || this.saving) return;
        const saved = await this.mutateSource('reopen_source', {});
        if (saved) await this.loadSources(true);
    }

    public async loadReviewHistory() {
        if (!this.selectedSource || !this.run) {
            this.reviewHistoryItems = [];
            return;
        }
        const data = await this.call('review_history', {
            ...this.identity(),
            source_id: this.selectedSource.source.id,
            limit: 20,
        });
        this.reviewHistoryItems = data.items || [];
    }

    private async mutateSource(
        apiName: string,
        payload: any,
        keepSpanId: string = null,
    ) {
        if (!this.selectedSource) return;
        this.saving = true;
        this.error = null;
        let saved = false;
        await this.service.render();
        try {
            const data = await this.call(apiName, {
                ...this.identity(),
                source_id: this.selectedSource.source.id,
                expected_revision: this.selectedSource.review.revision,
                ...payload,
            });
            this.selectedSource = data;
            const item = this.sourceResult.items.find(
                (row: any) => row.id === data.source.id
            );
            if (item) Object.assign(item, data.source);
            this.selectedSpan = null;
            this.overlappingSpans = [];
            if (keepSpanId) {
                const span = data.spans.find((row: any) => row.id === keepSpanId);
                if (span) this.setSelectedSpan(span);
            }
            await this.refreshOverviewMetrics();
            await this.loadReviewHistory();
            saved = true;
        } catch (error) {
            const message = error && error.message
                ? error.message
                : '검수 결정을 저장하지 못했습니다.';
            await this.service.modal.error(message);
        } finally {
            this.saving = false;
            await this.service.render();
        }
        return saved;
    }

    private async refreshOverviewMetrics() {
        const data = await this.call('overview', this.identity());
        this.counts = data.counts || {};
        this.blockers = data.finalization_blockers || [];
        this.capabilities = data.capabilities || {};
        this.proposalRun = data.proposal_run || null;
        this.reviewProgress = data.review || {};
    }

    private setSelectedSpan(span: any) {
        this.selectedSpan = span;
        const suggested = span.entity_type
            || (span.candidate_entity_types || [])[0]
            || 'PERSON';
        this.decisionType = suggested;
    }

    public async loadMentions() {
        if (!this.run) return;
        this.error = null;
        await this.beginPanelLoading();
        try {
            this.mentionResult = await this.call('mentions', {
                ...this.identity(),
                query: this.mentionQuery,
                entity_type: this.mentionType,
                page: this.mentionPage,
                dump: 50,
            });
        } catch (error) {
            this.applyError(error);
        } finally {
            await this.endPanelLoading();
        }
    }

    public async applyMentionFilter() {
        this.mentionPage = 1;
        await this.loadMentions();
    }

    public async moveMentionPage(direction: number) {
        const target = this.mentionPage + direction;
        if (target < 1) return;
        this.mentionPage = target;
        await this.loadMentions();
    }

    public async openMention(mention: any) {
        this.activeTab = 'source';
        this.syncTabUrl('source');
        if (!this.sourcesLoaded) {
            await this.loadSources(false, false);
        }
        if (this.error) return;
        await this.openSource(mention.source_record_id, mention.id);
    }

    public async loadEntities(selectFirst: boolean = false) {
        if (!this.run) return;
        this.error = null;
        await this.beginPanelLoading();
        try {
            this.entityResult = await this.call('entities', {
                ...this.identity(),
                query: this.entityQuery,
                entity_type: this.entityType,
                method: this.entityMethod,
                page: this.entityPage,
                dump: 50,
            });
            if (
                selectFirst
                || !this.selectedEntity
                || !this.entityResult.items.some(
                    (item: any) => item.id === this.selectedEntity.id
                )
            ) {
                if (this.entityResult.items.length > 0) {
                    await this.openEntity(this.entityResult.items[0].id);
                } else {
                    this.selectedEntity = null;
                }
            }
        } catch (error) {
            this.applyError(error);
        } finally {
            await this.endPanelLoading();
        }
    }

    public async applyEntityFilter() {
        this.entityPage = 1;
        await this.loadEntities(true);
    }

    public async setEntityMethod(method: string) {
        if (this.entityMethod === method) return;
        this.entityMethod = method;
        await this.applyEntityFilter();
    }

    public async moveEntityPage(direction: number) {
        const target = this.entityPage + direction;
        if (target < 1) return;
        this.entityPage = target;
        await this.loadEntities(true);
    }

    public async openEntity(entityId: string) {
        if (!entityId || !this.run) return;
        await this.beginPanelLoading();
        try {
            this.selectedEntity = await this.call('entity', {
                ...this.identity(),
                entity_id: entityId,
            });
        } catch (error) {
            this.applyError(error);
        } finally {
            await this.endPanelLoading();
        }
    }

    public async openEntityContext(context: any) {
        this.activeTab = 'source';
        this.syncTabUrl('source');
        if (!this.sourcesLoaded) {
            await this.loadSources(false, false);
        }
        if (this.error) return;
        await this.openSource(context.source_record_id, context.mention_id);
    }

    public async openSidebar() {
        await this.service.status.toggle('navbar', false);
    }

    public openDocuments() {
        location.href = '/documents';
    }

    public openRelationReview() {
        if (!this.run || !this.capabilities.relation_review) return;
        location.href = `/relation-review/${encodeURIComponent(this.run.document_id)}/${this.run.version}`;
    }

    public tabCount(tab: any) {
        if (!tab.countKey) return '';
        return this.formatNumber(this.counts[tab.countKey] || 0);
    }

    public formatNumber(value: number) {
        return new Intl.NumberFormat('ko-KR').format(value || 0);
    }

    public formatBytes(value: number) {
        if (!value || value < 1024) return this.formatNumber(value || 0) + ' B';
        return (value / 1024).toFixed(1) + ' KB';
    }

    public formatPercent(value: number) {
        if (typeof value !== 'number') return '-';
        return Math.round(value * 100) + '%';
    }

    public confidenceLabel(value: any) {
        if (typeof value === 'number') return this.formatPercent(value);
        return value || '-';
    }

    public rawScoreLabel(minimum: any, maximum: any) {
        if (typeof maximum !== 'number') return '-';
        if (typeof minimum !== 'number' || minimum === maximum) {
            return this.formatPercent(maximum);
        }
        return `${this.formatPercent(minimum)}~${this.formatPercent(maximum)}`;
    }

    public recommendationTotalPages() {
        return Math.max(
            1,
            Math.ceil((this.recommendationResult.total || 0) / 50),
        );
    }

    public modelFamilyLabel(value: string) {
        const labels: any = {
            'ai:gpt-5.6-sol': 'Sol',
            'ai:gpt-5.6-terra': 'Terra',
            'ai:gpt-5.6-luna': 'Luna',
            'symbolic:rules-review-v1': 'Rules',
        };
        return labels[value] || value || '-';
    }

    public agreementLabel(item: any) {
        if (!item) return '-';
        const agreement = item.agreement_strength || {};
        if (agreement.label) return agreement.label;
        const support = item.independent_group_support || 0;
        const eligible = agreement.eligible_group_count || 0;
        return eligible ? `${support}/${eligible}` : String(support);
    }

    public roleGateLabel(item: any) {
        if (!item || !item.role_gate) return '미측정';
        return item.role_gate_pass ? '역할 gate 통과' : '역할 gate 미통과';
    }

    public humanDecisionLabel(value: any) {
        if (!value) return '미검수';
        const labels: any = {
            accept: '사람 확정',
            exclude: '사람 제외',
            hold: '사람 보류',
        };
        return labels[value.action] || value.action || '미검수';
    }

    public sourceTotalPages() {
        return Math.max(1, Math.ceil((this.sourceResult.total || 0) / 60));
    }

    public formatDate(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '-';
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }).format(date);
    }

    public typeLabel(type: string) {
        const labels: any = {
            PERSON: '인물',
            POLITY: '국가·정체',
            PLACE: '장소',
            ORGANIZATION: '기관',
            OFFICE: '관직',
            EVENT: '사건',
            WORK: '문헌',
            TIME: '시간',
        };
        return labels[type] || type || '미정';
    }

    public originalKindLabel(kind: string) {
        const labels: any = {
            paragraph: '문단 원문',
            annotation: '주석 원문',
            table_cell: '표 셀 원문',
        };
        return labels[kind] || '원문 레코드';
    }

    public statusLabel(status: string) {
        const labels: any = {
            review: '검수 필요',
            extracted: '추출 완료',
            no_candidate: '후보 없음',
            review_required: '검수 필요',
            pending: '미검수',
            in_progress: '검수 중',
            held: '보류',
            completed: '완료',
            ready: '확정 가능',
            finalized: '최종 확정',
        };
        return labels[status] || status || '-';
    }

    public sourceStatusClass(status: string) {
        const styles: any = {
            review: 'border-amber-200 bg-amber-50 text-amber-800',
            extracted: 'border-blue-200 bg-blue-50 text-blue-700',
            pending: 'border-amber-200 bg-amber-50 text-amber-800',
            in_progress: 'border-indigo-200 bg-indigo-50 text-indigo-700',
            held: 'border-violet-200 bg-violet-50 text-violet-700',
            completed: 'border-green-200 bg-green-50 text-green-700',
            no_candidate: 'border-zinc-200 bg-zinc-50 text-zinc-600',
        };
        return styles[status] || styles.no_candidate;
    }

    public fragmentClass(fragment: any) {
        const base = 'kg-fragment rounded-sm px-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500';
        const tones: any = {
            candidate: ' kg-candidate',
            mention: ' kg-mention',
            confirmed: ' kg-confirmed',
            manual: ' kg-manual',
            excluded: ' kg-excluded',
            held: ' kg-held',
            overlap: ' kg-overlap',
            plain: ' kg-plain',
        };
        return base + (tones[fragment.tone] || tones.plain);
    }

    public entityMethodLabel(method: string) {
        const labels: any = {
            exact_label: '동일 표기 묶음',
            exact_alias_pair: '검증 별칭 묶음',
            singleton: '단일 Mention',
        };
        return labels[method] || method || '-';
    }

    public blockerLabel(blocker: string) {
        const labels: any = {
            unresolved_review_candidates: '미결 후보 343건',
            gold_threshold_not_evaluated: 'Gold 표본 기준 미평가',
            human_source_review_incomplete: '사람 원문 검수 미완료',
            held_review_decisions: '보류 결정 존재',
        };
        return labels[blocker] || blocker;
    }

    public silverStatusLabel(status: string) {
        const labels: any = {
            ready: '평가 준비 완료',
            not_ready: '평가 준비 전',
            provisional_pass: '잠정 통과',
            provisional_fail: '잠정 미달',
            not_evaluated: '평가 보류',
            gold_free_ready: '운영 평가 가능',
            gold_free_provisional_ready: '잠정 운영 평가 가능',
            gold_free_limited: '제한적 운영 평가',
            not_evaluable_insufficient_groups: '독립 그룹 부족',
            not_evaluable_no_reference: '평가 기준 없음',
            not_configured: '미설정',
            missing: '미등록',
            partial: '부분 등록',
            high_confidence_silver: 'Strict High',
            provisional_high_silver: 'Provisional High',
            medium_confidence_silver: 'Medium Silver',
            stable_unverified: '안정·독립성 미검증',
            single_source_only: '단일 그룹',
            contested: '충돌',
            omission_candidate: '누락 후보',
            invalid_by_constraint: '제약 위반',
            unknown: '근거 부족',
            not_selected: '최종 유형 미선택',
        };
        return labels[status] || status || '미등록';
    }

    public silverStatusClass(status: string) {
        if (status === 'ready' || status === 'provisional_pass' || status === 'gold_free_ready' || status === 'high_confidence_silver') {
            return 'border-green-200 bg-green-50 text-green-700';
        }
        if (status === 'partial' || status === 'provisional_fail' || status === 'gold_free_limited' || status === 'gold_free_provisional_ready' || status === 'provisional_high_silver' || status === 'medium_confidence_silver') {
            return 'border-amber-200 bg-amber-50 text-amber-800';
        }
        return 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public silverRoleLabel(producerId: string) {
        const labels: any = {
            generalist_agent_a: '범용 추출 A',
            generalist_agent_b: '범용 추출 B',
            person_extractor_agent: '인물 전문 추출',
            polity_extractor_agent: '국가·정체 전문 추출',
            place_extractor_agent: '장소 전문 추출',
            organization_extractor_agent: '기관 전문 추출',
            office_extractor_agent: '관직 전문 추출',
            event_extractor_agent: '사건 전문 추출',
            work_extractor_agent: '문헌 전문 추출',
            time_extractor_agent: '시간 전문 추출',
            omission_auditor_agent: '누락 감사',
            entityhood_agent: '개체성 검증',
            boundary_agent: '경계 검증',
            type_agent: '유형 검증',
            conflict_critic_agent: '충돌 비평',
            extraction_rules: '규칙 추출',
            codex_generator_legacy: '기존 Codex 추출',
        };
        return labels[producerId] || producerId || '-';
    }

    public silverBlockerLabel(blocker: string) {
        if (!blocker) return '-';
        if (blocker.startsWith('role_missing:')) {
            return `${this.silverRoleLabel(blocker.split(':')[1])} 실행본 누락`;
        }
        if (blocker.startsWith('role_partial:')) {
            return `${this.silverRoleLabel(blocker.split(':')[1])} coverage·입력 검증 미완료`;
        }
        const labels: any = {
            independent_groups_insufficient: '평가에 필요한 독립 그룹 수 미충족',
            gold_calibration_missing: 'Gold 표본 기반 신뢰도 보정 미설정',
            no_scorable_positive_labels: '점수 계산 가능한 Silver 양성 정답 없음',
            no_scorable_positive_reference: '평가 가능한 Silver 양성 정답 없음',
            target_prediction_resolved_coverage_insufficient: '평가 대상 예측의 판정 가능 비율 95% 미만',
            target_family_leakage_detected: '평가 대상과 같은 모델 계열 근거가 남아 있음',
            stability_missing: '재실행·입력 변형 안정성 산출물 없음',
            no_high_confidence_reference: 'High-confidence Silver 기준 없음',
            no_provisional_high_reference: 'Provisional High Silver 기준 없음',
        };
        return labels[blocker] || blocker;
    }

    public runStatusClass() {
        if (!this.run) return 'bg-zinc-100 text-zinc-600';
        if (this.run.status === 'finalized') return 'bg-green-50 text-green-700';
        if (this.run.status === 'ready') return 'bg-blue-50 text-blue-700';
        return 'bg-amber-50 text-amber-800';
    }

    public sourceFilterCount(status: string) {
        const workflowCounts = this.reviewProgress.queue_counts || {};
        if (status === 'all') return this.counts.source_count || 0;
        if (Object.prototype.hasOwnProperty.call(workflowCounts, status)) {
            return workflowCounts[status] || 0;
        }
        const counts = this.counts.source_status_counts || {};
        return counts[status] || 0;
    }

    public proposalOriginLabel(origin: string) {
        const labels: any = {
            baseline: 'baseline 제안',
            rule: '규칙 제안',
            ai: 'Codex 제안',
            both: '규칙·Codex 합의',
            manual: '사람 추가',
        };
        return labels[origin] || origin || '-';
    }

    public proposalStatusLabel(status: string) {
        const labels: any = {
            pending: '미검수',
            confirmed: '확정',
            excluded: '제외',
            held: '보류',
        };
        return labels[status] || status || '-';
    }

    public historyActionLabel(action: string) {
        const labels: any = {
            decision_accept: '후보 확정',
            decision_exclude: '후보 제외',
            decision_hold: '판단 보류',
            decision_revert: '결정 되돌림',
            manual_mention_added: 'Mention 직접 추가',
            source_completed: '원문 검수 완료',
            source_reopened: '원문 재검수',
        };
        return labels[action] || action || '-';
    }

    public mentionTypeCount(type: string) {
        const counts = this.counts.mention_type_counts || {};
        if (type === 'all') return this.counts.accepted_mention_count || 0;
        return counts[type] || 0;
    }

    private identity() {
        return {
            document_id: this.run.document_id,
            version: this.run.version,
        };
    }

    private routeIdentity() {
        const parts = location.pathname.split('/').filter((part: string) => !!part);
        const index = parts.indexOf('entity-review');
        if (index < 0 || !parts[index + 1]) return {};
        const documentId = decodeURIComponent(parts[index + 1]);
        const rawVersion = parts[index + 2] || '';
        const version = rawVersion.startsWith('v')
            ? rawVersion.slice(1)
            : rawVersion;
        return {
            document_id: documentId,
            version: version,
        };
    }

    private async beginPanelLoading() {
        this.panelLoadingCount += 1;
        this.panelLoading = true;
        await this.service.render();
    }

    private async endPanelLoading() {
        this.panelLoadingCount = Math.max(0, this.panelLoadingCount - 1);
        this.panelLoading = this.panelLoadingCount > 0;
        await this.service.render();
    }

    private async call(name: string, payload: any) {
        const { code, data } = await wiz.call(name, payload || {});
        if (code !== 200) {
            const message = data && data.error && data.error.message
                ? data.error.message
                : '개체 검수 데이터를 불러오지 못했습니다.';
            throw new Error(message);
        }
        return data;
    }

    private applyError(error: any) {
        this.error = {
            message: error && error.message
                ? error.message
                : '개체 검수 데이터를 불러오지 못했습니다.',
        };
    }

    private emptyPage() {
        return {
            items: [],
            page: 1,
            dump: 0,
            total: 0,
            has_previous: false,
            has_next: false,
        };
    }
}

export default PageEntityReviewComponent;